/**
 * @generated SignedSource<<7752b05a0a8bdae34a7f01febb9a6714>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type providerLogo_softwareReleasesLaunchCard$data = {
  readonly logoUrl: AGG$URL | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "providerLogo_softwareReleasesLaunchCard";
};
export type providerLogo_softwareReleasesLaunchCard$key = {
  readonly " $data"?: providerLogo_softwareReleasesLaunchCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"providerLogo_softwareReleasesLaunchCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "providerLogo_softwareReleasesLaunchCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "logoUrl"
    }
  ],
  "type": "DevOpsDeploymentProvider"
};

(node as any).hash = "a69ed29281953f2d0dd2061c60855b1f";

export default node;
